import { inject } from '@vercel/analytics'

export default defineNuxtPlugin(() => {
  // Inject Vercel analytics
  inject()
})
